import {changeFieldProperty, setFieldStartDate, setFieldVisibility, setSectionTKey} from "../../../../../apps/KpModule/actions";
import {GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";
import _ from "lodash";
import moment from "moment/moment";

export const module_ = {
    object: 'LiberalityRecord',
    name: 'LiberalityDecision',
    tKey: 'Décision',
    removable: false,
    newable: false,
    objectIdentifier: 'applicationNumber',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    formSections: [
        {
            id: 'benefactor',
            tKey: "Bienfaiteur(rice)",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'communDocuments',
            tKey: "Pièces communes aux biens",
            //Pièces communes et spécifiques du bien
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'receivables',
            tKey: "Dettes",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'conversationHistory',
            tKey: "Historique d'échanges",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
    ],
    viewMap: {
        dt: [
            {path: 'presentationDate', tKey: 'Présentation', initiallyNotVisible: true},
            {path: 'applicationNumber', tKey: 'N° dossier', initiallyNotVisible: true},
            {path: 'benefactor'},
            {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', initiallyNotVisible: true},
            {path: 'typeOfFile', display: 'code', initiallyNotVisible: true},
            {path: 'qualificationsDisplay', tKey: 'Qualification(s)', initiallyNotVisible: true},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)'},
            //{path: 'CNDABeneficiaries', tKey: 'CNDA Pour'},
            //{path: 'netAssets', tKey: 'Actif net (€)', tooltip: true},
            {path: 'netForecast', tKey: 'Net prévu (€)', tooltip: true},
            {path: 'CNDAShare', tKey: 'Dont part CNDA prévue (€)', tooltip: true, initiallyNotVisible: true},

            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], initiallyNotVisible: true},
            //{path: 'decisionDate', tKey: 'Date décision'},
            {path: 'updatedAt', tKey: 'MAJ par', initiallyNotVisible: true},
            {path: 'updatedBy', tKey: 'MAJ le', initiallyNotVisible: true},
        ],
        form: {
            fields: [
                {path: 'applicationNumber', tKey: 'N° dossier', disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'presentationDate', tKey: 'Date de présentation', disabled: true},
                {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', filters: ['eligibleToLiberalityProcess'], disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                {
                    path: 'typeOfFile',
                    display: 'fullName',
                    disabled: true,
                    widthClassName: "col-xs-12 col-sm-6",
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, getObjectSuccessAction }) => {
                            if(newValue && getObjectSuccessAction) {
                                const isLegs = newValue.id === 'legs'
                                const isLifeInsurance = newValue.id === 'lifeInsurance'

                                const actFeesField = module.viewMap.form.fields.find(field => field.path === 'actsFees')
                                const actFeesDetailsField = module.viewMap.form.fields.find(field => field.path === 'actsFeesDetails')

                                store.dispatch(setFieldVisibility(actFeesField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(actFeesDetailsField.id, !isLifeInsurance))

                                const assetsInfosField = module.viewMap.form.fields.find(field => field.path === 'assetsInfos')
                                const repartitionField = assetsInfosField.viewMap.form.fields.find(field => field.path === 'distribution')

                                const ownLiabilitiesFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'beneficiaryOwnLiabilities')

                                const qualificationListField = repartitionField.viewMap.dt.fields.find(field => field.path === 'qualification')
                                const qualificationFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'qualification')

                                const typeOfPropertyListField = assetsInfosField.viewMap.dt.fields.find(field => field.path === 'typeOfProperty')
                                const typeOfPropertyFormField = assetsInfosField.viewMap.form.fields.find(field => field.path === 'typeOfProperty')

                                // Passif propre: visible for LG, DO, DS (not AV)
                                store.dispatch(setFieldVisibility(ownLiabilitiesFormField.id, !isLifeInsurance))

                                // QF: visible only for LG
                                store.dispatch(setFieldVisibility(qualificationListField.id, isLegs))
                                store.dispatch(setFieldVisibility(qualificationFormField.id, isLegs))

                                // Natures du bien / Catégorie: visible for LG, DO, DS (not AV)
                                store.dispatch(setFieldVisibility(typeOfPropertyListField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(typeOfPropertyFormField.id, !isLifeInsurance))

                                const typeOfPropertyDisplay = isLegs ? 'category' : 'natureOfProperty'

                                store.dispatch(changeFieldProperty(typeOfPropertyListField.id, 'tKey', typeOfPropertyDisplay))
                                store.dispatch(changeFieldProperty(typeOfPropertyFormField.id, 'tKey', typeOfPropertyDisplay))
                            }
                        }
                    }
                },
                {
                    path: 'qualificationsDisplay',
                    tKey: 'Qualification(s)',
                    disabled: true,
                    widthClassName: "col-xs-12 col-sm-6",
                },

                {path: 'benefactorFirstName', section: 'benefactor', tKey: 'Prénom', required: true, widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorBirthName', section: 'benefactor', tKey: 'Nom de naissance', required: true, widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorMaritalStatus', section: 'benefactor', tKey: 'État matrimonial', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorMaritalName', section: 'benefactor', tKey: 'Nom marital', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorBirthDate', section: 'benefactor', tKey: 'Date de naissance', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorBirthPlace', section: 'benefactor', tKey: 'Lieu de naissance', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorDeathDate', section: 'benefactor', tKey: 'Date de décès', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorDeathPlace', section: 'benefactor', tKey: 'Lieu de décès', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorMainResidence', section: 'benefactor', tKey: 'Résidence principale', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'benefactorReservatoryHeirs', section: 'benefactor', tKey: 'Héritier/ère(s) réservataire(s)', widthClassName: "col-xs-12 col-sm-6", disabled: true},

                {path: 'beneficiariesDisplay', tKey: 'Bénéficiaire(s)', disabled: true},
                {path: 'netForecast', tKey: 'Net prévu (€)', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'CNDAShare', tKey: 'Dont part CNDA prévue (€)', widthClassName: "col-xs-12 col-sm-6", disabled: true},

                {path: "comment", type: "richTextEditor", disabled: true},

                {
                    path: 'stakeholders',
                    tKey: 'Partie(s) prenante(s)',
                    disabled: true,
                    viewMap: {
                        dt: [
                            {path: 'stakeholder.organization.organizationType.name', display: 'name', tKey: 'Type organisation'},
                            {path: 'stakeholder.organization.tradingName', tKey: "Nom d'usage de l'organisation"},
                            {path: 'stakeholder.fullName', tKey: 'Prénom Nom du contact'},
                            {path: 'stakeholder.mail', tKey: 'Courriel'},
                            {path: 'stakeholder.phone', tKey: 'Téléphone'},
                        ],
                        form: [
                            {
                                path: 'stakeholder',
                                tKey: 'Partie prenante',
                                display: 'completeInfo',
                                fieldPath: ['id', 'completeInfo', 'fullName', 'organization.organizationType.name', 'organization.tradingName', 'mail', 'phone'],
                                required: true,
                                filters: ['fromSupplierOrganization']
                            },
                        ]
                    }
                },
                {
                    path: 'assetsInfos',
                    tKey: 'Biens',
                    disabled: true,
                    viewMap: {
                        dt: [
                            {path: 'typeOfProperty', tKey: 'category'},
                            'identifier',
                            'estimatedAssetValue',
                            'assetLiabilities',
                            {path: 'estimatedAssetNetValue'},
                            'beneficiariesShareInAssetEstimatedValue',
                            'beneficiariesShareInAssetLiabilities',
                            'beneficiariesOwnLiabilities',
                            'beneficiariesShareInLiberalityRecordActsFees',
                            'estimatedBeneficiariesNetValue',
                            'CNDAShareInEstimatedBeneficiariesNetValue'
                        ],
                        form: [
                            {path: 'typeOfProperty', fieldPath: ['id', 'name', 'category', 'natureOfProperty'], tKey: 'category'},
                            {path: 'identifier'},
                            {path: 'comment', type: "richTextEditor"},
                            {path: 'estimatedAssetValue'},
                            {path: 'assetLiabilities'},
                            {
                                path: 'distribution',
                                tKey: 'Répartitions des biens',
                                viewMap: {
                                    dt: [
                                        {path: 'confFor', tKey: 'Pour'},
                                        {path: 'beneficiary', display: 'zipCodeAndName'},
                                        {path: 'qualification', tKey: 'Qualification'},
                                        {path: 'beneficiaryOwnLiabilities'},
                                        {path: 'actsFeesSupported'},
                                        {path: 'share', tKey: 'Quote-part'},
                                    ],
                                    form: [
                                        {path: 'confFor', tKey: 'CONF. DEFENSE DE L’ANIMAL POUR'},
                                        {path: 'beneficiary', display: 'zipCodeAndName'},
                                        {path: 'qualification'},
                                        {path: 'beneficiaryOwnLiabilities'},
                                        {path: 'actsFeesSupported'},
                                        {path: 'share', tKey: 'Quote-part'},
                                    ]
                                }
                            },
                        ],
                    }
                },

                {path: 'actsFees', tKey: 'Frais d’actes (€)', wholePositiveNumber: true, default: 0, required: true, disabled: true},
                {path: 'actsFeesDetails', tKey: 'Détails liés aux frais d’actes', type: "richTextEditor", disabled: true},

                {
                    path: 'filesList',
                    tKey: 'Pièces',
                    section: 'communDocuments',
                    disabled: true,
                    viewMap: {
                        dt: [
                            {path: 'fileCategory', tKey: 'title', display: 'title'},
                            {path: 'filesNumber'},
                            {path: 'noDeleteButtonAccess', hidden: true},
                        ],
                        form: [
                            {
                                path: 'fileCategory',
                                editable: false,
                                tKey: 'title',
                                display: 'title',
                                fieldPath: ['id', 'title', 'fileConfigurations'],
                                filters: ['getNecessaryOrUsefulByFileNatureAndExcludeAlreadyUsedForLiberalityRecord'],
                                warnIfNotFound: false
                            },
                            {
                                path: 'files',
                                type: 'simpleFiles',
                                fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'],
                            },
                            {path: 'noDeleteButtonAccess', hidden: true, default: false},
                            {path: 'filesNumber', hidden: true, default: 0},
                        ]
                    }
                },

                {
                    path: 'receivables',
                    tKey: 'Dettes',
                    section: 'receivables',
                    disabled: true,
                    viewMap: {
                        dt: [
                            {path: 'pieceNumber', tKey: 'N° pièce'},
                            {path: 'pieceDate', tKey: 'Date pièce', initiallyNotVisible: true},
                            {path: 'creditor', tKey: 'Créancier', display: 'name'},
                            {path: 'expenseCategory', tKey: 'Catégorie', display: 'name', initiallyNotVisible: true},
                            {path: 'totalAmount', tKey: 'Total (€)'},
                            {path: 'dueDate', tKey: "Date d'échéance", initiallyNotVisible: true},
                            {path: 'status', tKey: 'Statut', display: 'name'},
                            {path: 'settlementDate', tKey: 'Date règlement', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'pieceNumber', tKey: 'N° pièce', required: true, widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {
                                path: 'pieceDate',
                                tKey: 'Date pièce',
                                required: true,
                                editable: false,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store }) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const dueDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'dueDate')
                                        store.dispatch(setFieldStartDate(dueDateField.id, newValue || moment().format('YYYY-MM-DD')))
                                    }
                                }
                            },
                            {
                                path: 'creditor',
                                tKey: 'Créancier',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['isSupplier'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'expenseCategory',
                                tKey: 'Catégorie',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['active'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'totalAmount', tKey: 'Total (€)', required: true, widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {path: 'dueDate', tKey: "Date d'échéance", widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {
                                path: 'imputations',
                                tKey: 'Imputation(s)',
                                editable: true,
                                viewMap: {
                                    dt: [
                                        {path: 'asset', tKey: 'Bien', display: 'identifier'},
                                        {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                                        {path: 'beneficiaryShare', tKey: 'Quote-part (%)', numberOfDecimals: 2},
                                        {path: 'imputedAmount', tKey: 'Imputé (€)', type: 'editNumber', editable: true},
                                    ]
                                }
                            },
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store, formInitialize }) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const statusField = receivablesField.viewMap.form.fields.find(f => f.path === 'status')
                                        const settlementDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'settlementDate')

                                        const isSettled = newValue?.id === 'settled'
                                        store.dispatch(setFieldVisibility(settlementDateField.id, isSettled))
                                        store.dispatch(changeFieldProperty(settlementDateField.id, 'required', isSettled))
                                    }
                                }
                            },
                            {
                                path: 'settlementDate',
                                tKey: 'Date de règlement',
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor', editable: false},
                            {path: 'files', tKey: 'Pièces', type: 'simpleFiles'}
                        ]
                    }
                },

                {path: 'conversations', tKey: "interactionZone", section: 'conversationHistory'},

                {path: 'applicationNumber', hidden: true},
                {path: 'status', hidden: true},
                {path: 'buttons', hidden: true}
            ],
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const firstName = _.get(state, 'edit.object.data.benefactorFirstName', '')
                const birthName = _.get(state, 'edit.object.data.benefactorBirthName', '')
                const nameSuffix = [firstName, birthName].filter(Boolean).join(' ')
                store.dispatch(setSectionTKey('benefactor', nameSuffix ? `Bienfaiteur(rice) : ${nameSuffix}` : 'Bienfaiteur(rice)'))
            }
        }
    ],
    filters: [
        {
            path: "awaitingDecision",
            query: () => {
                return {status: 'awaitingDecision'}
            }
        },
        'inPresentationBeforeOrToday'
    ]
}
